import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Link } from 'react-router';
import classNames from 'classnames';


export default function AgreementLink({ agreement, className, children }) {
  if (!agreement || _.isEmpty(agreement)) return null;

  return (
    <Link to={`/admin/agreements/${agreement.id}`} className={classNames('agreement-link', className)}>
      {children || agreement.title}
    </Link>
  );
}

AgreementLink.propTypes = {
  agreement: PropTypes.object,
  className: PropTypes.string,
  children: PropTypes.node
};
